import { useQuery } from '@tanstack/react-query';
import React, { useEffect, useState } from 'react';
import { Col, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { fetchHRCodeList } from '../../../store/apis/commonService';

function RiskCountryModal({ isOpen, toggle, country, onConfirm, onCancel }) {
  const [url, setUrl] = useState('');
  const { data: riskCountryURL } = useQuery({
    queryKey: ['riskCountryURL', country],
    queryFn: () =>
      fetchHRCodeList({ type: 'TRAVEL_RISK_URLS', param1: country }),
    enabled: isOpen && country && country.length > 0,
  });

  useEffect(() => {
    if (riskCountryURL && riskCountryURL.length > 0) {
      const urlData = riskCountryURL[0];
      setUrl(urlData?.URL || '');
    }
  }, [riskCountryURL]);

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      className="risk-country-modal"
      size="md"
      centered
    >
      <ModalHeader toggle={toggle}>Risk Country</ModalHeader>
      <ModalBody>
        <div className="d-flex gap-2 flex-column">
          <div>
            <span>
              You are travelling to risk country. You need to check at least
              both the &quot;International SOS&quot; website and your own
              Government&apos;s advice web site.
            </span>
          </div>
          <div>
            <a
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              className="fw-semibold"
            >
              Click for Details
            </a>
          </div>
        </div>
      </ModalBody>
      <ModalFooter className="d-flex flex-row gap-2 w-100">
        <Col>
          <button
            type="button"
            className="custom-btn w-100"
            onClick={onConfirm}
          >
            Confirm
          </button>
        </Col>
        <Col>
          <button
            type="button"
            className="custom-danger-btn w-100"
            onClick={onCancel}
          >
            Cancel
          </button>
        </Col>
      </ModalFooter>
    </Modal>
  );
}

export default RiskCountryModal;
